<template>
  <div class="footer-toolbar">
    <div @click="imageClickEvent('home')">
      <img v-if="$store.state.toolbarActivePosition === 'main'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/home-active.png" width="16" height="19" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/home.png" width="16" height="19" />
      <div class="label">홈</div>
    </div>
    <div @click="imageClickEvent('mytextbook')">
      <img v-if="$store.state.toolbarActivePosition === 'mytextbook'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/mytextbook-active.png" width="22" height="19" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/mytextbook.png" width="22" height="19" />
      <div class="label">플레이리스트</div>
    </div>
    <div @click="imageClickEvent('preview')">
      <img v-if="$store.state.toolbarActivePosition === 'preview'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/find-active-dh.png" width="75" height="75" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/find-dh.png" width="75" height="75" />
      <div class="label">동화찾기</div>
      <!-- 버튼 눌려짐 버그로 원복
      <img v-if="$store.state.toolbarActivePosition === 'preview'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/find-active.png" width="75" height="75" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/find.png" width="75" height="75" />
      <div class="label">동화찾기</div>
      -->
    </div>
    <div @click="imageClickEvent('join')">
      <img v-if="$store.state.toolbarActivePosition === 'join'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/join-active.png" width="19" height="19" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/join.png" width="19" height="19" />
      <div class="label">참여하기</div>
    </div>
    <div @click="imageClickEvent('mypage')">
      <img v-if="$store.state.toolbarActivePosition === 'mypage'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/mypage-active.png" width="18" height="19" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/common/footer-toolbar/mypage.png" width="18" height="19" />
      <div class="label">My</div>
    </div>
  </div>
</template>

<script>
import * as alert from '../../utils/alert';
import * as biz from '../../utils/biz';

export default {
  name: "FooterToolbar",
  data() {
    return {
      isActive: "main"
    }
  },
  created() {
    // 미니플레이어 뛰우기
    const footer = document.querySelector('body > ion-app > div.player > div.mini-player');
    if (footer !== null) footer.bottom = "56px";
  },
  methods: {
    imageClickEvent(div) {

      biz.setAudioPlayer();

      const today = new Date();
      switch (div) {
        case "home":
          this.$store.state.toolbarActivePosition = "main";
          this.$router.replace({path: "/", query: {key: today.toISOString()}});
          break;
        case "mytextbook":
          if (!biz.isLogin(this)) {
            alert.alertLogin(this);
            return;
          }

          this.$store.state.toolbarActivePosition = "mytextbook";
          this.$router.replace({path: "/mytextbook/playlist", query: {key: today.toISOString()}});
          // alert.alert("교과진도 서비스 준비 중 입니다.", "확인");
          break;
        case "preview":
          this.$store.state.toolbarActivePosition = "preview";
          // this.$router.replace({path: "/preview/main", query: {key: today.toISOString()}});
          this.$router.replace({path: '/preview/lecture/subject/' + '00', query: { key: today.toISOString() }});
          break;
        case "join":
          this.$store.state.toolbarActivePosition = "join";
          this.$router.replace({path: "/mycontent/main", query: {key: today.toISOString()}});
          break;
        case "mypage":
          this.$store.state.toolbarActivePosition = "mypage";
          this.$router.replace({path: "/mypage/main", query: {key: today.toISOString()}});
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
div.footer-toolbar {
  position: fixed;
  left: 0;
  bottom: 0;

  width: 100%;
  height: 56px;
  background-color: white;
  border-top: 1px solid $line-third-color;
  z-index: 105;

  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    width: 25%;
    text-align: center;
    font-size: $font-base10;
    font-weight: 500;

    div.label {
      margin-top: -2px;
      width: 100%;
    }
  }
}
</style>
